import ParamValidator from '@rd-web-markets/shared/dist/models/ParamValidator';
import { FormattedNumberInput, Table } from '@rd-web-markets/shared/dist/util';
import React from 'react';
import benefitAdjustmentsService from '../../services/claim/benefit_adjustments.service';
import { Loader } from '@rd-web-markets/shared/dist/util/Loader';
import ChangeHighlightedImmutableUnderReviewControl from '@rd-web-markets/shared/dist/util/reviewEditControls/ChangeHighlightedImmutableUnderReviewControl';
import { replaceInArray } from '@rd-web-markets/shared/dist/util/arrayUtils/arrayUtils';

/**
 * type
 */
export default function BenefitAdjustmentsTable(_ref) {
  let {
    claim,
    type,
    setLoading,
    adjustments,
    setAdjustments
  } = _ref;
  ParamValidator.validateValueIn('BenefitAdjustmentsTable', type, ['adduction', 'deduction']);
  const createAdjustment = benefitAdjustmentsService.useCreate({
    claimId: claim.id,
    setLoading,
    setAdjustments
  });
  const updateAdjustment = benefitAdjustmentsService.useUpdate({
    claimId: claim.id,
    setLoading,
    setAdjustments
  });
  const deleteAdjustment = benefitAdjustmentsService.useDelete({
    claimId: claim.id,
    setLoading,
    setAdjustments
  });
  const removeAdjustment = adjustment => {
    if (adjustment.id && !(typeof adjustment.id === 'string')) {
      deleteAdjustment(adjustment);
    } else {
      setAdjustments([...adjustments.filter(a => a.id !== adjustment.id)]);
    }
  };
  const updateOrCreateAdjustment = adjustment => {
    if (typeof adjustment.id === 'string') {
      createAdjustment({
        adjustment_type: adjustment.adjustment_type,
        amount: adjustment.amount
      });
    } else {
      updateAdjustment(adjustment);
    }
  };
  if (!adjustments) {
    return /*#__PURE__*/React.createElement(Loader, null);
  }
  const headers = [{
    text: ''
  }, {
    text: ''
  }];
  const rows = adjustments.filter(adjustment => adjustment.adjustment_type === type).map(adjustment => ({
    data: {
      object: adjustment
    },
    key: adjustment.id,
    columns: [/*#__PURE__*/React.createElement(ChangeHighlightedImmutableUnderReviewControl, {
      as: FormattedNumberInput,
      onChange: _ref2 => {
        let {
          target: {
            value: amount
          }
        } = _ref2;
        return setAdjustments(replaceInArray(a => a.id === adjustment.id, {
          ...adjustment,
          amount
        }));
      },
      onBlur: () => updateOrCreateAdjustment(adjustment),
      disabled: claim.financials_locked,
      name: "amount",
      style: {
        textAlign: 'right'
      },
      object: {
        ...adjustment,
        claim: {
          ...claim
        }
      }
    })]
  }));
  return /*#__PURE__*/React.createElement(React.Fragment, null, rows.length ? /*#__PURE__*/React.createElement(Table, {
    headers: headers,
    rows: rows,
    onDelete: (index, row) => removeAdjustment(row.data.object)
  }) : '');
}